/**
 * The "tour running" flag of this browser tab (`sessionStorage`). A reload keeps the guide bar.
 * The step comes from the server (`onboarding.state`), so only the flag is stored here.
 * Each read and write is in try/catch: a private window can block the storage.
 */
const TOUR_ACTIVE_KEY = 'm24TourActive';

export function readStoredTourActive(): boolean {
  try {
    return sessionStorage.getItem(TOUR_ACTIVE_KEY) === '1';
  } catch {
    return false;
  }
}

export function storeTourActive(active: boolean): void {
  try {
    if (active) {
      sessionStorage.setItem(TOUR_ACTIVE_KEY, '1');
    } else {
      sessionStorage.removeItem(TOUR_ACTIVE_KEY);
    }
  } catch {
    // The storage is blocked. The tour still runs until the next reload.
  }
}
